"use client";

import { ClientError } from "graphql-request";

const extractStatus = (error: unknown) => {
  if (!error || typeof error !== "object") {
    return null;
  }

  if ("response" in error) {
    const response = (error as { response?: unknown }).response;
    if (response && typeof response === "object" && "status" in response) {
      const status = (response as { status?: unknown }).status;
      return typeof status === "number" ? status : null;
    }
  }

  if ("status" in error) {
    const status = (error as { status?: unknown }).status;
    return typeof status === "number" ? status : null;
  }

  if ("statusCode" in error) {
    const status = (error as { statusCode?: unknown }).statusCode;
    return typeof status === "number" ? status : null;
  }

  return null;
};

const extractRequestId = (error: unknown) => {
  if (!error || typeof error !== "object") {
    return null;
  }

  if ("response" in error) {
    const response = (error as { response?: unknown }).response;
    if (
      response &&
      typeof response === "object" &&
      "errors" in response &&
      Array.isArray((response as { errors?: unknown }).errors)
    ) {
      const errors = (response as { errors: Array<{ extensions?: { request_id?: string } }> }).errors;
      return errors[0]?.extensions?.request_id ?? null;
    }
  }

  return null;
};

export const formatBillingError = (error: unknown) => {
  if (error instanceof ClientError) {
    const status = error.response.status;
    const requestId = error.response.errors?.[0]?.extensions?.request_id;
    const parts = ["Unable to load billing details."];

    if (status) {
      parts.push(`Status ${status}.`);
    }

    if (requestId) {
      parts.push(`Request ID ${requestId}.`);
    }

    return parts.join(" ");
  }

  const status = extractStatus(error);
  const requestId = extractRequestId(error);
  const parts = ["Unable to load billing details."];

  if (status) {
    parts.push(`Status ${status}.`);
  } else {
    parts.push("Status unavailable.");
  }

  if (requestId) {
    parts.push(`Request ID ${requestId}.`);
  }

  return parts.join(" ");
};
